export default {"src":"/_next/static/media/asx_white_sans_text_01.83ae8211.svg","height":171,"width":114,"blurWidth":0,"blurHeight":0};